import { useToastList } from './toast';

/** Where `toast()` messages show: once, at the root of the app. */
export function Toasts() {
  const toasts = useToastList();
  return (
    <div className="toast-viewport" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className="toast">
          {t.text}
        </div>
      ))}
    </div>
  );
}
